class FaviconNotification {
  constructor() {
    this.canvas = null;
    this.originalFavicon = null;
    this.isNotificationActive = false;
    this.storageKey = 'pando_notification_active';
    this.activityKey = 'pando_user_active';
    this.tabId = Date.now() + Math.random();
  }

  init() {
    const faviconLink = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
    if (faviconLink) {
      this.originalFavicon = faviconLink.href;
    }

    window.addEventListener('storage', (e) => {
      if (e.key === this.storageKey) {
        if (e.newValue === 'true' && !this.isAnyTabActive()) {
          this.showNotificationIcon();
        } else {
          this.hideNotificationIcon();
        }
      }
      if (e.key === this.activityKey) {
        if (e.newValue) {
          this.hideNotificationIcon();
        }
      }
    });
    this.markTabActive();
    if (localStorage.getItem(this.storageKey) === 'true' && !this.isAnyTabActive()) {
      this.showNotificationIcon();
    }
  }

  showNotification() {
    localStorage.setItem(this.storageKey, 'true');
    if (!this.isAnyTabActive()) {
      this.showNotificationIcon();
    }
  }

  hideNotification() {
    localStorage.removeItem(this.storageKey);
    this.hideNotificationIcon();
  }

  showNotificationIcon() {
    if (this.isNotificationActive) return;
    this.isNotificationActive = true;

    this.canvas = document.createElement('canvas');
    this.canvas.width = 32;
    this.canvas.height = 32;
    const ctx = this.canvas.getContext('2d');

    const img = new Image();
    img.onload = () => {
      ctx.drawImage(img, 0, 0, 32, 32);

      ctx.fillStyle = '#ff0000';
      ctx.beginPath();
      ctx.arc(24, 8, 6, 0, 2 * Math.PI);
      ctx.fill();

      this.updateFavicon(this.canvas.toDataURL());
    };
    img.src = this.originalFavicon || '/favicon.ico';
  }

  hideNotificationIcon() {
    if (!this.isNotificationActive) return;

    this.isNotificationActive = false;
    this.updateFavicon(this.originalFavicon || '/favicon.ico');
  }

  updateFavicon(href) {
    let faviconLink = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');

    if (!faviconLink) {
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      document.head.appendChild(faviconLink);
    }

    faviconLink.href = href;
  }

  markTabActive() {
    localStorage.setItem(this.activityKey, this.tabId);
  }

  markTabInactive() {
    if (localStorage.getItem(this.activityKey) === this.tabId.toString()) {
      localStorage.removeItem(this.activityKey);
    }
  }

  isAnyTabActive() {
    return localStorage.getItem(this.activityKey) !== null;
  }
}

export default FaviconNotification;
